import React, { useState, useEffect, useRef } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import toast, { Toaster } from 'react-hot-toast';
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import { logIssuanceHistory, getIssuanceRecords, getIssuanceDetail, getWarehouseKeyValueList } from '../../../services/index';
import AddIcon from '@mui/icons-material/Add';
import { Table } from 'react-bootstrap';
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { searchForMatch } from '../../utils/textUtils';
import { useReactToPrint } from 'react-to-print';
import Select from 'react-select';
import { Warehouse } from '@mui/icons-material';

const ViewIssuance = () => {
    let { id } = useParams();
    const [logData, setLogData] = useState({});
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [rows2, setRows2] = useState([]);
    const [issuanceDetails, setIssuanceDetails] = useState([]);
    const [tabIndex, setTabIndex] = useState(0);
    const [index, setIndex] = useState(0);
    const [filterText, setFilterText] = useState("");
    const [issuanceListDetails, setIssuanceListDetails] = useState(null);
    const [search, setSearch] = useState("");

    const componentRef = useRef();
    const [wareOptions, setWareOptions] = useState("");
    const [ware, setWare] = useState("");
    const [selectedWarehouse, setSelectedWarehouse] = useState("");
    const [selectedRecordId, setSelectedRecordId] = useState("");
    const location = useLocation();

    useEffect(() => {
        setTabIndex(0);
    }, [id]);

    useEffect(() => {
        if (tabIndex === 1) {
            logIssuanceHistory(issuanceDetails.issuanceCode).then((res) => {
                if (res.errorCode === 0) {
                    const d = res.responsePacket;
                    setLogData(d);
                } else {
                    toast(res.message);
                }
            });
        } else {
            getIssueDetails(id);
        }
    }, [tabIndex]);

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                if (location.state?.ware) {
                    setSelectedWarehouse(location.state.ware)
                }
                else {
                    setSelectedWarehouse(options[0]);
                }
                setWareOptions(options);
            }
        });
    }, []);

    const getIssueDetails = (id) => {
        getIssuanceDetail(id).then((res) => {
            if (res.errorCode === 0) {
                let d1 = res.responsePacket.issuanceDate;
                let dd = new Date(d1).toISOString().replace(/T.*/, '').split('-').reverse().join('-');
                res.responsePacket.issuanceDate = dd;
                setIssuanceDetails(res.responsePacket);
                setLoading(true);
            } else {
                toast.error(res.message);
            }
        });
    };

    const getAllIssuanceRecords = (e) => {
        let issuance_data = {
            page: index,
            size: 15,
            search: filterText,
            uuid2: e || selectedWarehouse.value
        };
        getIssuanceRecords(issuance_data).then((res) => {
            if (res.errorCode === 0) {
                if (index === 0) {
                    setRows(res.responsePacket.data);
                    setRows2(res.responsePacket.data);
                } else {
                    const setIssuanceRecordsClone = [...rows, ...res.responsePacket.data];
                    setRows(setIssuanceRecordsClone);
                    setRows2(setIssuanceRecordsClone);
                }
                setIssuanceListDetails({
                    recordsFiltered: res.responsePacket.recordsFiltered,
                    recordsTotal: res.responsePacket.recordsTotal,
                    total: res.responsePacket.total,
                })
            } else {
                toast(res.message);
            }
        }).catch((error) => {
            console.error(error);
        });
    };

    useEffect(() => {
        if (rows.length > 0) {
            //  id = rows[0].recordId;
            //  setSelectedRecordId(id);
            getIssueDetails(id);
        }
    }, [rows]);

    useEffect(() => {
        if (selectedWarehouse) {
            getAllIssuanceRecords();
        }
    }, [filterText, index, selectedWarehouse])


    let time;
    const handleSearch = (e) => {
        const { value } = e.target;
        clearTimeout(time);
        time = setTimeout(() => {
            setFilterText(value);
            setIndex(0);
        }, 500);
    };

    const handleSelectWarehouse = (e) => {
        setSelectedWarehouse(e);
        getAllIssuanceRecords(e.value);
        setIndex(0);
        setSearch("");
    };

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });


    return (
        <>
            <div className='list-column column d-print-none' style={{ width: '300px' }}>
                <div className="fill list-header topgrad d-print-none">
                    <div className="list-filter pt-3 d-flex align-items-center">
                        <div className="listFilterAndSearch">
                            <Link to="/issueitems/new" className="newListBtn">
                                <AddIcon />
                                {/* New */}
                            </Link>
                            <div className="listFilter">
                                <Select value={selectedWarehouse} options={wareOptions} onChange={handleSelectWarehouse} />
                            </div>
                            <div className="input-group paginationSearchInput listSearch">
                                <div className="input-group-prepend ">
                                    <span className="input-group-text" id="basic-addon1">
                                        <SearchRoundedIcon />
                                    </span>
                                </div>
                                <input autoComplete="off" className="form-control" type="text" placeholder="Search..." onChange={handleSearch} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='scroll-y fill body scrollbox list-body'>
                    <div className='table-responsive overflow-initial'>
                        <table id='ember7912' className='table zi-table table-hover ember-view header-fixed'>
                            {rows && (rows.length > 0 ?
                                (<tbody>
                                    {rows.map((row, i) => (
                                        <tr key={i} onClick={() => getIssueDetails(row.recordId)} className={`listTr ${selectedRecordId === row.recordId ? 'activeRecord' : ''}`}>
                                            <td>
                                                <Link to={`/issueitems/${row.recordId}`} className={`${selectedRecordId === row.recordId ? 'text-primary' : 'text-grey'}`}>
                                                    <span className='titleTr'>{row.issuanceCode}</span>
                                                    <span className='d-flex justify-content-between'>
                                                        <span>{row?.issuedDepartmentTitle}</span>
                                                        <span>By: {row?.issuedByUserTitle}</span>
                                                    </span>
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                    {
                                        issuanceListDetails &&
                                        issuanceListDetails.recordsTotal >
                                        rows.length && (
                                            <div className="pt-3">
                                                <button
                                                    className="btn mx-auto newListBtn"
                                                    onClick={() => setIndex(index + 1)}
                                                // onClick = {getAllIssuanceRecords}
                                                >
                                                    Load More
                                                </button>
                                            </div>

                                        )}
                                </tbody>) : (<div className="my-3 text-black text-center">No Data Available!</div>)
                            )}
                        </table>
                    </div>
                </div>
            </div>

            <div className='column content-column ' style={{ left: '301px' }}>
                <div className='header no-border d-flex align-items-center p-4'>
                    <h3 className='over-flow header-title'>
                        &nbsp;
                    </h3>
                </div>
                <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)} className='upperTabs'>
                    <TabList>
                        <Tab>Primary Details</Tab>
                        <Tab>Log History</Tab>
                    </TabList>
                    <TabPanel>
                        <div ref={componentRef} className='ember-view scroll-y noscroll-x fill body scrollbox'>
                            <button className="tooltip-container ember-view btn btn-primary print-btn position-absolute" onClick={handlePrint} style={{ top: "0px", right: "0px" }}>
                                <LocalPrintshopOutlinedIcon />
                            </button>
                            <br />
                            <div id='scroll'>
                                <div className='font-large text-uppercase font-xs text-open mb-2'>{issuanceDetails.issuanceCode}</div>
                                <table className='customTable borderedTable'>
                                    <tbody>
                                        {issuanceDetails?.requisitionCode ? (
                                            <tr>
                                                <td className='font-large text-uppercase font-xs text-open'>{issuanceDetails?.requisitionCode}</td>
                                            </tr>
                                        ) : (
                                            <></>
                                        )}
                                        {issuanceDetails.issuedToUserTitle ? (
                                            <tr>
                                                <td>Issued To:</td>
                                                <td>{issuanceDetails.issuedToUserTitle}</td>
                                            </tr>
                                        ) : (
                                            ''
                                        )}
                                        <tr>
                                            <td>Issued By:</td>
                                            <td>{issuanceDetails.issuedByUserTitle}</td>
                                        </tr>
                                        <tr>
                                            <td>Issuance Date:</td>
                                            <td>{issuanceDetails.issuanceDate}</td>
                                        </tr>
                                        <tr>
                                            <td>Department:</td>
                                            <td>{issuanceDetails.issuedDepartmentTitle}</td>
                                        </tr>
                                        <tr>
                                            <td>Warehouse:</td>
                                            <td>{issuanceDetails.warehouseTitle}</td>
                                        </tr>
                                        <tr>
                                            <td>Note By Issuer:</td>
                                            <td>{issuanceDetails.noteByIssue}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr />

                            <div className='' id='scroll'>
                                {!loading ? (
                                    'Loading...'
                                ) : (
                                    issuanceDetails && issuanceDetails.issuedItemsList && issuanceDetails.issuedItemsList.length !== 0 ? (
                                        <div>
                                            <h3 className='font-size-16'>ISSUED ITEMS</h3>
                                            <table className='customTable borderedTable'>
                                                <thead>
                                                    <tr>
                                                        <td>S No.</td>
                                                        <td>Item</td>
                                                        <td>SKU</td>
                                                        <td>Quantity</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {issuanceDetails.issuedItemsList.map((item, i) => (
                                                        <tr key={i}>
                                                            <td>{i + 1}</td>
                                                            <td>{item.itemTitle}</td>
                                                            <td>{item.itemSku}</td>
                                                            <td>
                                                                {item.issuedQuantity}&nbsp;
                                                                {item.issuedQuantityUnitTitle}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            {issuanceDetails.returnedIssuedItemsList.length > 0 && <>
                                                <h3 className='font-size-16 mt-3'>RETURN ITEMS</h3>
                                                <table className='customTable borderedTable'>
                                                    <thead>
                                                        <tr>
                                                            <td>S No.</td>
                                                            <td>Item</td>
                                                            <td>Qty</td>
                                                            <td>Status</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {issuanceDetails.returnedIssuedItemsList.map((item, i) => (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>{item.itemTitle}</td>
                                                                <td>
                                                                    {item.returnQuantity}&nbsp;
                                                                    {item.unitTitle}
                                                                </td>
                                                                <td>{item.status}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </>}
                                        </div>
                                    ) : (
                                        <div>No issued items available.</div>
                                    )
                                )}
                                <div id='ember3382' className='ember-view'></div>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <div className='ember-view scroll-y noscroll-x fill body scrollbox py-3'>
                            <table>
                                {logData.length === 0 ? (
                                    'No Changes Found'
                                ) : (
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th>Changes</th>
                                        </tr>
                                    </thead>
                                )}
                                {logData.length >= 1 && (
                                    <tbody>
                                        {logData?.map((history, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className='mr-2' style={{ verticalAlign: 'top', width: '100px' }}>
                                                        {history?.transactionDate?.substring(0, 10)}
                                                        <br />
                                                        Time:
                                                        {history?.transactionDate?.split('T')[1]?.substring(0, 5)}
                                                    </td>
                                                    <td>
                                                        <div dangerouslySetInnerHTML={{ __html: history?.message.replaceAll("\n", "<br />").replaceAll("\t", "&nbsp;&nbsp;&nbsp;&nbsp;") }} />
                                                        {/* {history?.message.split('\n').map((b, j) => (
                                                            <div key={j}>{b.includes('\t') ? <div className='ml-4'>{b}</div> : b.includes('\t\t') ? <div className='ml-4'>{b}</div> : b}</div>
                                                        ))} */}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                )}
                            </table>
                        </div>
                    </TabPanel>
                </Tabs>
            </div>
            <Toaster />
        </>
    );
};
export default ViewIssuance;